// product-model.js — hardened XR setup with payload normalization

if (!customElements.get('product-model')) {
  customElements.define('product-model', class ProductModel extends DeferredMedia {
    constructor() {
      super();
    }

    loadContent() {
      super.loadContent();

      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.setupModelViewerUI.bind(this),
        },
      ]);
    }

    setupModelViewerUI(errors) {
      if (errors) return;
      const mv = this.querySelector('model-viewer');
      if (!mv) return;
      try {
        this.modelViewerUI = new Shopify.ModelViewerUI(mv);
      } catch (e) {
        console.warn('[ModelViewerUI] init failed:', e);
      }
    }
  });
}

(function(){
  function isGid(v) {
    return typeof v === 'string' && v.startsWith('gid://shopify/');
  }

  // Try to coerce any payload into XR model objects:
  // Expected minimal shape per item: { modelId: <gid Model3d>, mediaId?: <gid Media> }
  function normalizeToXRModels(payload) {
    const out = [];

    const pushIfModel = (obj) => {
      if (!obj || typeof obj !== 'object') return;

      // Common direct shapes
      if (isGid(obj.modelId)) {
        // optional mediaId OK if present
        out.push({ modelId: obj.modelId, mediaId: isGid(obj.mediaId) ? obj.mediaId : undefined });
        return;
      }

      // Some themes attach `id` for the model itself
      if (isGid(obj.id) && (obj.__typename === 'Model3d' || obj.media_type === 'model' || obj.contentType === 'MODEL_3D')) {
        out.push({ modelId: obj.id, mediaId: obj.id });
        return;
      }

      // model nested under `model` or `data`
      if (obj.model && isGid(obj.model.id)) {
        out.push({ modelId: obj.model.id, mediaId: isGid(obj.id) ? obj.id : undefined });
        return;
      }
    };

    // CASE A: Already an array of models/medias
    if (Array.isArray(payload)) {
      payload.forEach(pushIfModel);
      return out;
    }

    // CASE B: Single object that itself is a model/media
    if (payload && typeof payload === 'object') {
      // Themes sometimes embed under `models`, `media`, or `product.media`
      if (Array.isArray(payload.models)) payload.models.forEach(pushIfModel);
      if (Array.isArray(payload.media)) payload.media.forEach(pushIfModel);

      // product-style wrapper
      if (payload.product && Array.isArray(payload.product.media)) {
        payload.product.media.forEach(pushIfModel);
      }

      // as a last check, maybe this object itself is a model/media
      pushIfModel(payload);
    }

    return out;
  }

  window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },

    setupShopifyXR(errors) {
      if (errors) return;

      // XR not ready yet? wait once
      if (!window.ShopifyXR) {
        const handler = () => {
          document.removeEventListener('shopify_xr_initialized', handler);
          this.setupShopifyXR();
        };
        document.addEventListener('shopify_xr_initialized', handler, { once: true });
        return;
      }

      const nodes = document.querySelectorAll('[id^="ProductJSON-"]');
      const models = [];

      Array.from(nodes).forEach((node) => {
        const raw = (node.textContent || '').trim();
        node.remove(); // avoid reprocessing
        if (!raw) return;

        try {
          const parsed = JSON.parse(raw);
          const normalized = normalizeToXRModels(parsed);
          if (normalized.length) {
            models.push(...normalized);
          } else {
            console.warn('[ShopifyXR] Skipped non-XR payload from', node.id, parsed);
          }
        } catch (e) {
          console.warn('[ShopifyXR] Invalid JSON in', node.id, e);
        }
      });

      // Only pass *valid* model items to addModels
      const validModels = models.filter(m => m && isGid(m.modelId));
      if (validModels.length && typeof window.ShopifyXR.addModels === 'function') {
        try {
          window.ShopifyXR.addModels(validModels);
        } catch (e) {
          console.error('[ShopifyXR] addModels failed even after normalization:', e, validModels);
        }
      } else if (!validModels.length) {
        console.warn('[ShopifyXR] No valid XR models found in ProductJSON-* nodes.');
      }

      if (typeof window.ShopifyXR.setupXRElements === 'function') {
        try { window.ShopifyXR.setupXRElements(); } catch (e) { console.warn('[ShopifyXR] setupXRElements failed:', e); }
      }
    },
  };

  window.addEventListener('DOMContentLoaded', () => {
    if (window.ProductModel) window.ProductModel.loadShopifyXR();
  });
})();
